import { isAuthenticatedPreview, RootURL } from "./cms-api";

let lastNavigation = "";
let clearPending: (() => void) | undefined;

/** One visible, successfully loaded page per navigation; no browser storage. */
export function trackPublicPage(pageId: number | null, navigation: string) {
  try {
    if (isAuthenticatedPreview || RootURL === "/preview-api/" ||
        window.location.hostname === "beteiligung.steg-gis.de" ||
        window.location.pathname.indexOf("/cms-preview/") === 0 ||
        new URLSearchParams(window.location.search).get("cms_preview") === "1" ||
        navigator.doNotTrack === "1" || (navigator as any).globalPrivacyControl === true) return;
    const key = navigation + ":" + String(pageId);
    if (lastNavigation === key) return;
    lastNavigation = key;
    if (clearPending) clearPending();
    const send = () => {
      try {
        if (document.visibilityState !== "visible") return;
        if (clearPending) clearPending();
        const random = new Uint8Array(16);
        window.crypto.getRandomValues(random);
        random[6] = (random[6] & 15) | 64;
        random[8] = (random[8] & 63) | 128;
        const hex = Array.from(random).map(value => ("0" + value.toString(16)).slice(-2)).join("");
        const eventId = hex.slice(0, 8) + "-" + hex.slice(8, 12) + "-" + hex.slice(12, 16) + "-" + hex.slice(16, 20) + "-" + hex.slice(20);
        // Query strings, referrers, credentials and page contents are never sent.
        void fetch(new URL("../monitoring/public-page-visits/", RootURL).toString(), {
          method: "POST", credentials: "omit", referrerPolicy: "no-referrer", keepalive: true,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ page_id: pageId, event_id: eventId }),
        }).catch(() => undefined);
      } catch { /* Monitoring must never interrupt public page rendering. */ }
    };
    const visible = () => send();
    clearPending = () => { document.removeEventListener("visibilitychange", visible); clearPending = undefined; };
    if (document.visibilityState === "visible") send();
    else document.addEventListener("visibilitychange", visible);
  } catch { /* Monitoring is best effort. */ }
}
